import { countTotalAllDivs } from "../helpers/countTotal.js";
import { cofs_update } from "./express-bets_cofs_updater.js";
import {toFixed} from '../global.js';

(function ($) {
    // Uncheck all item checkboxes inside inventory after page load
    $('#js__items input.item_checkbox_js').prop('checked', false);

    // Set input range value to 0 and trigger change event
    $('input.input-range').val(0).trigger('change');
    $('input.input-range-value').val(0).trigger('change');
    $('input[name="user_betcoin"]').val(0);


    //need update countTotalAndProfit
    $('body').on('update:totalandprofit', function () {
        countTotalAndProfit();
    });


    //items clicks
    $('.block__item').on('click', '.pay__item', function (e) {
        if ($(this).find('input[type=checkbox]').length == 0) {
            return;
        }
        let in_bet_div = $('#js__bet_up');
        let user_inventory_div = $('#js__items')
        if ($(this).parents('#js__items').length) {
            //in inventory click move to in_bet
            //if bet is started do nothing
            if ($('.bet-item.active.started').length != 0) {
                return;
            }
            //set hidden input checked true
            $(this).find('input.item_checkbox_js').prop('checked', true);
            in_bet_div.append($(this));
        } else {
            if ($('.bet-item.active.started').length != 0) {
                return;
            }
            //if item was in bet onload do nothing
            if ($(this).find('input.item_checkbox_js').length == 0) {
                return;
            }
            //set hidden input checked false
            $(this).find('input.item_checkbox_js').prop('checked', false);
            //in bet click move to inventory
            user_inventory_div.append($(this));
        }
        countTotalAndProfit();
    });


    //click on bet item left
    $('.bet-item:not(.disabled)[data-cof]').on('click', function (e) {
        let $expressDiv = $('.block__item.form_for_js_in_div .modal-bet-item .block__item-wrapper');
        let $betTypeDiv = $(this).parents('.card-bet__item');
        let tournamentId = $betTypeDiv.data('tournament_id')

        //if we already have bet on same tournament remove it    
        if ($(this).hasClass('active')) {
            //if its active bet remove it
            $(e.target).data('skip-click', true);
            $(this).removeClass('active');
            $expressDiv.find(`[data-tournament_id="${tournamentId}"] .js-close`).click();
            return;
        } else {
            //if its not active bet remove all bets from this tournament
            $expressDiv.find(`[data-tournament_id="${tournamentId}"] .js-close`).click();
        }


        let $matchDiv = $betTypeDiv.parents('.games');
        let cof = $(this).data('cof');
        let team = $(this).data('team');
        let betType = $betTypeDiv.find('[data-bet_type]').data('bet_type');
        let gameIconClass = $matchDiv.find('.games-card-icon').attr('class').split(' ').filter(c => c.includes('bc'))[0];
        let betTypeName = $betTypeDiv.find('[data-bet_type]').text();
        let betTypeHtml = $betTypeDiv.find('[data-bet_type] div').html();
        let tournamentName = $matchDiv.find('.games-top-name').text();
        let timeToLive = $matchDiv.find('.games-top-time').text();
        let game = $matchDiv.data('game');
        let team1Name = $matchDiv.find('.games-card-left .games-card-title span').text();
        let team1ImgSrc = $matchDiv.find('.games-card-left .games-card-img img').attr('src');
        let team2Name = $matchDiv.find('.games-card-right .games-card-title span').text();
        let team2ImgSrc = $matchDiv.find('.games-card-right .games-card-img img').attr('src');
        let isLocked = $matchDiv.find('.js_lock_icon').is(':visible');






        let $newExpressDiv = createExpressDiv(cof, team, tournamentId, gameIconClass, betType, betTypeName, betTypeHtml, tournamentName, timeToLive, game, team1ImgSrc, team2ImgSrc, team1Name, team2Name, isLocked);
        $expressDiv.append($newExpressDiv);
        countTotalAndProfit();
    })

    //click on close bet right
    $('.block__item.form_for_js_in_div .modal-bet-item .block__item-wrapper').on('click', '.js-close', function () {
        var $parentDiv = $(this).parents('.games');
        var tournamentId = $parentDiv.data("tournament_id");
        var betType = $parentDiv.data("bet_type");
        var team = $parentDiv.data("team");
        $(`[data-tournament_id="${tournamentId}"] [data-bet_type="${betType}"]`).parents('.games-wrapper').find(`.bet-item.active[data-team="${team}"]`).removeClass(`active`);

        countTotalAndProfit();
    })


    let ignore_countTotal = false;
    function countTotalAndProfit() {
        if (ignore_countTotal) {
            return;
        }
        countTotalAllDivs();
        var totalCof = 1;
        var totalBetsCount = 0;
        $('[data-cof_express]').each(function () {
            totalCof *= $(this).data('cof_express');
            totalBetsCount++;
        });
        var items_value = Number($('.in_bet .user_items_price').text());
        var betcoin_value = 0; // Number($('input.input-range-value').val());
        // console.log(totalCof);
        totalCof = toFixed(totalCof, 3);
        //  console.log(totalCof);
        //  console.log(betcoin_value);
        //  console.log(items_value);
        var totalReward = toFixed(totalCof * (betcoin_value + items_value), 2);
        // console.log(totalReward);
        //console.log(totalCof, totalReward);
        $('.express_bet__total_cof_value').text(`x${totalCof}`);
        $('.express_bet__reward_value').text(totalReward);
        $('.express_bet__total_bet_value').text(toFixed(betcoin_value + items_value, 2));
        $('.express_bets_count').text(totalBetsCount);
        $('.express_cof').text(`${totalCof}`);


        //show/hide placeholders
        let $expressDiv = $('.block__item.form_for_js_in_div .modal-bet-item .block__item-wrapper');
        if ($expressDiv.find('.games').length == 0) {
            $expressDiv.find('.empty_placeholder').show();
        } else {
            $expressDiv.find('.empty_placeholder').hide();
        }
        let $leftDiv = $('.block__item.toggle-wrap-all');
        if ($leftDiv.find('.games:visible').length == 0) {
            $leftDiv.find('.empty_placeholder').show();
        } else {
            $leftDiv.find('.empty_placeholder').hide();
        }

    };




    //adding betcoins
    $('.bet__range').on('input change', 'input.input-range', function () {
        var $betcoin_div = $('.bet-content-coin');
        var $betcoin_span = $betcoin_div.find('span[data-betcoin]');
        var current_value = Number($betcoin_span.data('betcoin'));
        var added_value = Number($(this).val());
        if (!$(this).is(':visible')) {
            added_value = 0;
        }
        // if (Number($('input.bet-content__range_value:visible').val()) != $added_value) {
        //     $('input.bet-content__range_value:visible').val($added_value);
        // }
        var total_bet_value = Number(current_value + added_value);
        if (total_bet_value <= 0) {
            total_bet_value = 0;
            $betcoin_div.addClass('hidden');
        } else {
            $betcoin_div.removeClass('hidden');
        }
        $betcoin_span.html(toFixed(total_bet_value, 2));

        //главный инпут куда надо записать валуе
        $('input[name="user_betcoin"').val(added_value);

        countTotalAndProfit();
    });
    $('.bet__range').on('focusout', 'input.input-range-value', function () {
        if ($(this).val() == '') {
            $(this).val(0);
        }
    });
    $('.bet__range').on('focus', 'input.input-range-value', function () {
        if ($(this).val() == 0) {
            $(this).val('');
        }
    });


    function createExpressDiv(cof, team, tournamentId, gameIconClass, betType, betTypeName, betTypeHtml, tournamentName, timeToLive, game, team1ImgSrc, team2ImgSrc, team1Name, team2Name, isLocked = false) {
        return `
                                                <div class="games bet min right item-close" data-tournament_id="${tournamentId}" data-team="${team}" data-bet_type="${betType}">
                                                    <input type="hidden" name="express_matches[${tournamentId}][${betType}][${team}]" value="${cof}">
                                                    <div class="games-top">
                                                        <div class="games-top-time">
                                                            <span>${timeToLive}</span>
                                                        </div>
                                                        <div class="games-top-name">${tournamentName}</div>
                                                    </div>
                                                    <div class="games-wrapper">
                                                        <a href="#" class="games-card">
                                                            <span class="games-card-coin delete js-close js-close--no-body-handle">
                                                                <svg viewBox="0 0 8 8" width="8" height="8" fill="#c8c8c8" class="icon item-svg" data-img="/template/images/svg/cross.svg">
                                                                <path></path>
                                                                <path d="M65.611,719.545c-0.278.317-.563,0.625-0.833,0.88l-1.538,1.454c0.786,0.742,1.725,1.863,2.459,2.576,0.606,0.612.224,1.8-.687,1.5a12.125,12.125,0,0,1-2.111-1.9,3.142,3.142,0,0,0-.933-0.834,2.539,2.539,0,0,0-.687.648c-0.495.492-1.015,0.958-1.522,1.436a1.4,1.4,0,0,1-1.031.649c-0.627.025-1.085-.7-0.344-1.5,0.279-.317.564-0.82,0.835-1.075,0.512-.483,1.024-0.835,1.536-1.271-0.782-.742-1.713-1.855-2.441-2.564-0.6-.612-0.224-1.8.686-1.5a12.1,12.1,0,0,1,2.106,1.9,3.168,3.168,0,0,0,.931.834,2.525,2.525,0,0,0,.686-0.649c0.494-.491,1.012-0.957,1.519-1.435a1.394,1.394,0,0,1,1.029-.649C65.894,718.019,66.351,718.743,65.611,719.545Z" transform="translate(-58 -718)"></path>
                                                            </svg>
                                                            </span>
                                                            <span class="games-card-icon ${gameIconClass}"></span>
                                                            <span class="games-card-info">
                                                                <span class="games-card-wrap">
                                                                    <span class="games-card-left games-card-item ${team == "team_1" ? "bet-block" : ""}">
                                                                        <span class="games-card-title">
                                                                            <span>${team1Name}</span>
                                                                        </span>
                                                                        <span class="games-card-img">
                                                                            <img class="" src="${team1ImgSrc}" alt="${team1Name}">
                                                                        </span>
                                                                    </span>
                                                                    <span class="games-card-center games-card-item">
                                                                        <span class="games-card-score min">
                                                                            <span>
                                                                                <svg viewBox="0 0 10 17" width="10" height="17" fill="#fff" class="js_lock_icon icon item-svg" data-img="/template/images/svg/lock.svg" style="${isLocked?'':'display: none;'}">
                                                                                    <path d="M982.547,390c2.039-.027,3.163.911,3.483,2.591l0.036,3.167c2.323,0,1.884,2.773,1.884,5.111a9.707,9.707,0,0,1-.107,2.843,2.03,2.03,0,0,1-1.6,1.26h-4.728a7.176,7.176,0,0,1-2.2-.108,2.111,2.111,0,0,1-1.138-1.152,5.987,5.987,0,0,1-.106-1.835c0-1.426-.276-4.381.284-5.255a2.321,2.321,0,0,1,1.635-.9c-0.026-2.621-.174-4.328,1.458-5.326Zm0.426,1.512c-1.4.56-1.493,0.722-1.493,2.663l0.036,1.583,3.021-.036C984.575,393.5,984.918,391.862,982.973,391.512Zm0,6.91c-0.855.327-1.9,0.833-1.386,2.123a9.526,9.526,0,0,0,.675.756c0.218,0.472.086,1.157,0.889,0.972,0.592-.137.369-0.451,0.6-0.972l0.569-.54C985.034,399.566,984.026,398.6,982.973,398.422Z" transform="translate(-978 -389)"></path>
                                                                                </svg>
                                                                                <svg viewBox="0 0 7 16" width="7" height="16" fill="#c8c8c8" class="js_arrows_up_icon icon item-svg" data-img="/template/images/svg/arrows-up.svg" style="display: none;">
                                                                                    <path d="M919.732,471.73c-1.028-.935-2.517-2.727-3.177-2.73a1.5,1.5,0,0,0-.859.569l-1.631,1.441c-0.237.209-.486,0.461-0.73,0.72-0.648.656-.248,1.25,0.3,1.229a1.237,1.237,0,0,0,.9-0.531c0.444-.392.9-0.773,1.331-1.176a2.152,2.152,0,0,1,.6-0.53,2.708,2.708,0,0,1,.816.682,10.329,10.329,0,0,0,1.846,1.555A0.7,0.7,0,0,0,919.732,471.73Zm0-3c-1.028-.935-2.517-2.727-3.177-2.73a1.5,1.5,0,0,0-.859.569l-1.631,1.441c-0.237.209-.486,0.461-0.73,0.72-0.648.656-.248,1.25,0.3,1.229a1.237,1.237,0,0,0,.9-0.531c0.444-.392.9-0.773,1.331-1.176a2.152,2.152,0,0,1,.6-0.53,2.708,2.708,0,0,1,.816.682,10.329,10.329,0,0,0,1.846,1.555A0.7,0.7,0,0,0,919.732,468.73Z" transform="translate(-913 -461.5)"></path>
                                                                                </svg>
                                                                                <svg viewBox="0 0 7 16" width="7" height="16" fill="#c8c8c8" class="js_arrows_down_icon icon item-svg" data-img="/template/images/svg/arrows-down.svg" style="display: none;">
                                                                                    <path style="rotate: -180deg; transform-origin: 3.5px 8px;" d="M919.732,471.73c-1.028-.935-2.517-2.727-3.177-2.73a1.5,1.5,0,0,0-.859.569l-1.631,1.441c-0.237.209-.486,0.461-0.73,0.72-0.648.656-.248,1.25,0.3,1.229a1.237,1.237,0,0,0,.9-0.531c0.444-.392.9-0.773,1.331-1.176a2.152,2.152,0,0,1,.6-0.53,2.708,2.708,0,0,1,.816.682,10.329,10.329,0,0,0,1.846,1.555A0.7,0.7,0,0,0,919.732,471.73Zm0-3c-1.028-.935-2.517-2.727-3.177-2.73a1.5,1.5,0,0,0-.859.569l-1.631,1.441c-0.237.209-.486,0.461-0.73,0.72-0.648.656-.248,1.25,0.3,1.229a1.237,1.237,0,0,0,.9-0.531c0.444-.392.9-0.773,1.331-1.176a2.152,2.152,0,0,1,.6-0.53,2.708,2.708,0,0,1,.816.682,10.329,10.329,0,0,0,1.846,1.555A0.7,0.7,0,0,0,919.732,468.73Z" transform="translate(-913 -461.5)"></path>
                                                                                </svg>
                                                                            </span>
                                                                        </span>
                                                                    </span>
                                                                    <span class="games-card-right games-card-item ${team == "team_2" ? "bet-block" : ""}">
                                                                         <span class="games-card-img">
                                                                            <img class="" src="${team2ImgSrc}" alt="${team2Name}">
                                                                        </span>
                                                                        <span class="games-card-title lose">
                                                                            <span>${team2Name}</span>
                                                                        </span>
                                                                    </span>
                                                                </span>
                                                            </span>
                                                        </a>
                                                        <div class="games-card-bet">
                                                            <div class="card-bet__item" data-cof_express="${cof}">
                                                                <b>x<span class="js_cof">${cof}</span></b>
                                                                <div class="bet-item bet-item-img">
                                                                    <div class="flex-jac min ${betTypeName.includes('Live') ? 'live' : ''}">
                                                                        ${betTypeHtml}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>`
    };


})(jQuery);
